import { MatchSocketRepository } from "../repositories/SocketRepository";
import { LikeParams } from "../entities/emitLikeParams";

export class OnNotificationLike {
	constructor(private repository: MatchSocketRepository) {}
	execute(callback: (data: LikeParams) => void): void {
		return this.repository.onNotificationLike(callback);
	}
}
